import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-form search-form--hotel" }
const _hoisted_2 = { class: "form-wrapper form-wrapper--rail" }
const _hoisted_3 = { class: "search-form__destination search-form__destination--hotels" }
const _hoisted_4 = { class: "search-form__destination search-form__destination--date" }
const _hoisted_5 = { class: "count-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Взрослые ")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "(старше 12 лет)", -1)
const _hoisted_8 = { class: "buttons-wrapper" }
const _hoisted_9 = { class: "count-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Дети ")
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "(до 12 лет)", -1)
const _hoisted_12 = { class: "buttons-wrapper" }
const _hoisted_13 = {
  key: 0,
  class: "all-params__wrapper"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_datepicker = _resolveComponent("datepicker")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("label", null, [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.selectedCity,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.selectedCity = $event)),
              field: "complexName",
              placeholder: "Город",
              suggestions: _ctx.lists.cities,
              loading: _ctx.isLoading,
              onComplete: _cache[2] || (_cache[2] = $event => (_ctx.asyncFind($event))),
              onItemSelect: _cache[3] || (_cache[3] = $event => (_ctx.setCity($event)))
            }, null, 8, ["modelValue", "suggestions", "loading"])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_datepicker, {
            placeholder: "Дата заезда",
            "monday-first": true,
            onSelected: _ctx.setDate,
            "wrapper-class": "vuejs3-datepicker__wrapper",
            "disabled-dates": _ctx.disabledDatesFrom
          }, null, 8, ["onSelected", "disabled-dates"]),
          _createVNode(_component_datepicker, {
            placeholder: "Дата выезда",
            "monday-first": true,
            "disabled-dates": _ctx.disabledDatesTo,
            onSelected: _ctx.calculateNights,
            "wrapper-class": "vuejs3-datepicker__wrapper vuejs3-datepicker__wrapper--right"
          }, null, 8, ["disabled-dates", "onSelected"])
        ]),
        _createVNode(_component_Accordion, null, {
          default: _withCtx(() => [
            _createVNode(_component_AccordionTab, {
              header: 
              `Взрослый: ${_ctx.requestObj.adults}; Ребенок: ${_ctx.requestObj.children}`
            
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("h4", null, [
                    _hoisted_6,
                    _hoisted_7,
                    _createTextVNode(": " + _toDisplayString(_ctx.requestObj.adults), 1 /* TEXT */)
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("button", {
                      disabled: _ctx.requestObj.adults === 4,
                      class: "btn-plus",
                      onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.increaseCount('adults')), ["prevent"]))
                    }, null, 8, ["disabled"]),
                    _createVNode("button", {
                      disabled: _ctx.requestObj.adults === 1,
                      class: "btn-minus",
                      onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.decreaseCount('adults')), ["prevent"]))
                    }, null, 8, ["disabled"])
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("h4", null, [
                    _hoisted_10,
                    _hoisted_11,
                    _createTextVNode(": " + _toDisplayString(_ctx.requestObj.children), 1 /* TEXT */)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("button", {
                      disabled: _ctx.requestObj.children === 4,
                      class: "btn-plus",
                      onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.increaseCount('children')), ["prevent"]))
                    }, null, 8, ["disabled"]),
                    _createVNode("button", {
                      disabled: _ctx.requestObj.children === 0,
                      class: "btn-minus",
                      onClick: _cache[7] || (_cache[7] = _withModifiers($event => (_ctx.decreaseCount('children')), ["prevent"]))
                    }, null, 8, ["disabled"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }),
        _createVNode("button", {
          type: "submit",
          class: "search-form__submit search-form__submit--hotel",
          onClick: _cache[8] || (_cache[8] = _withModifiers((...args) => (_ctx.searchData(...args)), ["prevent"])),
          disabled: !_ctx.disabledSearch
        }, null, 8, ["disabled"])
      ]),
      _createVNode("a", {
        href: "#",
        class: "login-restore-link",
        onClick: _cache[9] || (_cache[9] = _withModifiers($event => (_ctx.showParams = !_ctx.showParams), ["prevent"]))
      }, "Все параметры"),
      (_ctx.showParams)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode(_component_AutoComplete, {
              minLength: 3,
              modelValue: _ctx.selectedClient,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.selectedClient = $event)),
              placeholder: "Выберите клиента",
              field: "entityName",
              suggestions: _ctx.lists.clients,
              onComplete: _cache[11] || (_cache[11] = $event => (_ctx.searchClient($event))),
              onItemSelect: _cache[12] || (_cache[12] = $event => (_ctx.setClient($event))),
              dropdown: true
            }, null, 8, ["modelValue", "suggestions"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}